import NBType, { InferType } from '@netbase/nb-type'
import ChannelLevel from '../enums/ChannelLevel'
import SocialWebChannelType from '../enums/SocialWebChannelType'

/**
 * @typedef {import('../enums/ChannelLevel').ChannelLevel} ChannelLevel
 * @typedef {import('../enums/SocialWebChannelType').SocialWebChannelType} SocialWebChannelType
 */

/**
 * @typedef {object} SimpleChannelSchema
 * @property {string} channelId
 * @property {string} inputValue
 * @property {ChannelLevel} level
 * @property {string} name
 * @property {SocialWebChannelType} type
 */
const SimpleChannelSchema = NBType.object().shape('SimpleChannelSchema', {
  /* @prop */
  channelId: NBType.string(),
  /* @prop */
  inputValue: NBType.string(),
  /* @prop */
  level: NBType.enum(ChannelLevel),
  /* @prop */
  name: NBType.string(),
  /* @prop */
  type: NBType.enum(SocialWebChannelType)
  /* END */
})
export default SimpleChannelSchema
export type SimpleChannel = InferType<typeof SimpleChannelSchema>
// RESERVE BELOW
